
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-789e09ea&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./SelfBuildingSquareSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./SelfBuildingSquareSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-789e09ea!../../../../vue-loader/lib/selector?type=template&index=0!./SelfBuildingSquareSpinner.vue"),
  /* scopeId */
  "data-v-789e09ea",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/SelfBuildingSquareSpinner.vue
// module id = 872
// module chunks = 1